import React, { useContext } from 'react'
import styles from './LaboralAdicional.module.css'
import Subtitle from '../Subtitle'
import GeneralContext from '../../context/GeneralContext'

//Utiles
import * as Constantes from '../../utils/constantes'
import * as Funciones from '../../utils/funciones'

const LaboralAdicional = ({ aseguradoAdicional, state, setState }) => {
    const { state: generalState } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

    const handleChangeEmpleador = (e, campo, tipo) => {
        let valor = e.target.value
		setState((state) => {
			return {
				...state,
				aseguradoAdicional: {
					...state.aseguradoAdicional,
					[campo]: valor
				},
				campoValidadoAdicional: {
					...state.campoValidadoAdicional,
					[campo]: true
				}
			}
		})
}

    const handleChangeNumerico2 = (e, campo) => {
        let value = e.target.value
        const re = /^[0-9\b.,]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            setState((state) => {
                return {
                    ...state,
                    aseguradoAdicional: {
                        ...state.aseguradoAdicional,
                    	[campo]: Funciones.cantidadStringToFloat(value)
                    },
                    campoValidadoAdicional: {
                        ...state.campoValidadoAdicional,
                        [campo]: true
                    }
                }
            })
        }
    }
    //Modo lectura
    let Deshabilitar = (complete) => {
        complete = cotizacion.edicionInhabilitada
        if (complete === true) {
            return true
        } else {
            return false
        }
    }

    let contenido = null
    if (aseguradoAdicional) {//TODO: Pendiente hacer cambios para Asegurado
        contenido = <div className={styles['areadatosprospecto']}>
            <Subtitle
                sname="Laboral"
                smostrar="false"
            />
            <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                <div className={styles['area75']}>
                    <label>Empleador / Empresa&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input type='text'
                        className={!state.campoValidadoAdicional.empresa ? styles['logerror'] : null}
                        value={aseguradoAdicional.empresa || ''}
                        onChange={(e) => handleChangeEmpleador(e, 'empresa', 'a')}
                        disabled={Deshabilitar() !== true ? false : true}
                        maxLength={130}
                        style={{ textTransform: "capitalize" }}
                    />
                    {!state.campoValidadoAdicional.empresa &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_EMPLEADOR_EMPRESA}</span>
                    }
                </div>
                <div className={styles['area25']}>
                    <label>Ingreso anual en S/ &nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
                    <input
                        type='text'
                        className={!state.campoValidadoAdicional.ingresoAnual ? `${styles['logerror']} ${styles['tipoLabores']}` : styles['tipoLabores']}
                        value={Funciones.formatoMonedaLaboral(aseguradoAdicional.ingresoAnual)}
                        options={{
                            numeral: false,
                            numeralThousandsGroupStyle: 'thousand'
                        }}
                        maxLength={9} //CMUNAYLLA: se cambia por la longitud pedida
                        onChange={(e) => handleChangeNumerico2(e, 'ingresoAnual')}
                        disabled={Deshabilitar() !== true ? false : true}
                    />
                    {!state.campoValidadoAdicional.ingresoAnual &&
                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_INGRESO_ANUAL}</span>
                    }
                </div>
            </div>
        </div>
    } 

    return contenido
}

export default LaboralAdicional